import { colors, fonts, screen } from 'components/styles/variables';
import autolistLogoRed from 'public/static/images/autolist-logo-red.png';
import hero from 'public/static/images/used_cars_welcome/hero.png';
import heroLarge from 'public/static/images/used_cars_welcome/hero-large.png';

export default `
  .navbar {
    height: 57px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .content-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 0 24px;
    height: 100vh;
    font-family: ${fonts.default};
  }
  .vehicle-category {
    width: 136px;
    height: 163px;
    border: 1px solid #d3d3d3;
    border-radius: 8px;
  }
  .vehicle-category:hover {
    cursor: pointer;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.08);
  }
  .vehicle-label {
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    letter-spacing: 0.2px;
    text-transform: uppercase;
    color: #333333;
    background-color: white;
    margin-top: 10px;
  }
  .onboarding-autolist-logo {
    background-image: url(${autolistLogoRed});
    background-size: contain;
    background-repeat: no-repeat;
    width: 160px;
    height: 22px;
  }
  .category-header,
  .vehicle-category-container,
  .search-button {
    display: none;
  }
  .category-header {
    text-transform: uppercase;
    font-weight: 700;
    letter-spacing: 0.2px;
    line-height: 22px;
    font-size: 18px;
    width: 100%;
    max-width: 1392px;
    margin-top: 40px;
    text-align: center;
    justify-content: center;
    gap: 12px;
  }
  .line {
    width: 28px;
    height: 2px;
    background: ${colors.ALR1};
    margin-top: 10px;
  }
  .header-title {
    font-weight: 700;
    color: white;
    font-size: 34px;
    line-height: 46px;
    letter-spacing: 0.2px;
    text-align: center;
    margin-top: 72px;
  }
  .searching-section {
    display: flex;
    color: white;
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0.2px;
    line-height: 20px;
    justify-content: center;
    margin-bottom: 45px;
    margin-top: 32px;
    align-items: center;
    gap: 5px;
  }
  .location-container {
    color: white;
    font-size: 14px;
    border-bottom: 1px solid white;
  }
  .search-bar {
    display: flex;
    align-items: center;
    position: relative;
  }
  .search-input {
    width: 100%;
    max-width: 440px;
    height: 56px;
    border-radius: 100px;
    border: 1px solid ${colors.G2};
    padding: 8px 8px 8px 57px;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.2px;
    background: white;
    display: flex;
    align-items: center;
    cursor: text;
  }
  .search-input::placeholder {
    color: ${colors.G3};
  }
  .search-icon {
    position: absolute;
    left: 24px;
  }
  .search-button {
    width: 128px;
    height: 40px;
    border-radius: 100px;
    background: ${colors.ALR1};
    padding: 8px 12px;
    color: white;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0.2px;
    text-align: center;
    position: absolute;
    right: 8px;
    cursor: pointer;
  }
  .social-proof {
    margin: 40px 0;
    padding: 0 24px;
    position: absolute;
    bottom: 0;
  }
  .social-proof img {
    max-width: 100%;
    height: auto;
  }
  .search-header {
    height: 100%;
    width: 100vw;
    background-image: url(${heroLarge});
    background-size: cover;
    border-radius: 0px;
    display: flex;
    flex-direction: column;
    align-content: center;
    // justify-content: flex-start;
    align-items: center;
  }
  .header-content {
    width: 322px;
  }
  @media (min-width: 850px) {
    .navbar {
      height: 85px;
    }
    .category-header {
      display: flex;
    }
    .vehicle-category-container {
      display: grid;
      grid-gap: 13px;
      margin-top: 24px;
      grid-template-columns: repeat(2, 1fr);
    }
    .vehicle-category {
      width: 389px;
      height: 212px;
    }
    .vehicle-image {
      height: 171px;
      width: 387px;
      border-radius: 8px 8px 0 0;
      object-fit: cover;
    }
    .search-header {
      border-radius: 24px;
      max-width: 1150px;
      height: 500px;
      justify-content: space-between;
    }
    .content-container {
      margin: 0;
      height: initial;
    }
    .header-title {
      font-size: 34px;
      line-height: 46px;
    }
    .social-proof {
      display: block;
      padding: 0;
      margin: 0 0 30px 0;
      position: relative;
      bottom: auto;
    }
    .social-proof img {
      height: initial;
      width: revert-layer;
    }
  }
  @media (min-width: ${screen.lgMin}) {
    .search-header {
      background-image: url(${hero});
      background-size: cover;
      align-items: center;
    }
    .search-button {
      display: block;
    }
    .header-title {
      font-size: 44px;
    }
    .header-content {
      width: 440px;
    }
    .vehicle-category-container {
      grid-template-columns: repeat(5, 1fr);
      grid-gap: 26px;
      margin: 32px 0 200px 0;
    }
    .vehicle-category {
      width: 211px;
      height: 194px;
    }
    .vehicle-image {
      width: 209px;
      height: 155px;
    }
  }
`;
